import React, { useState } from "react";
import { DarkModeSwitch } from "react-toggle-dark-mode";

const ThemeBgSwitcher = ({ colorTheme, setTheme }) => {
  const [darkSide, setDarkSide] = useState(
    colorTheme === "light" ? true : false
  );

  const toggleDarkMode = (checked) => {
    setTheme(colorTheme);
    setDarkSide(checked);
  };

  return (
    <div className="flex justify-center items-center gap-3">
      {/* <h5 className='font-semibold text-md text-gray-900 dark:text-slate-200'>Theme : </h5> */}
      <DarkModeSwitch
        checked={darkSide}
        onChange={toggleDarkMode}
        className="w-8 h-8 sm:w-8 sm:h-8 icon-dl"
      />
    </div>
  );
};

export default ThemeBgSwitcher;
